import React from 'react';

// Arabic version of the privacy policy content (the English page remains the reference text)
const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-bold text-slate-900 mb-4">{title}</h2>
    {children}
  </section>
);

const P = ({ children }) => <p className="text-slate-600 leading-relaxed mb-4">{children}</p>;
const List = ({ children }) => <ul className="list-disc ps-6 text-slate-600 space-y-2 mb-4">{children}</ul>;

const PrivacyPolicyAr = () => (
  <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
    <h1 className="text-3xl font-extrabold text-slate-900 mb-2">سياسة الخصوصية</h1>
    <p className="text-slate-500 mb-2">آخر تحديث: 27 يناير 2026</p>
    <p className="text-xs text-slate-400 mb-8">
      هذه ترجمة عربية للتسهيل. في حال وجود أي اختلاف بين النسختين، تُعتمد النسخة الإنجليزية.
    </p>

    <div className="prose prose-slate max-w-none">
      <Section title="1. مقدمة">
        <P>
          مرحبًا بك في ArabCap. نحن نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح سياسة الخصوصية هذه كيف
          نجمع معلوماتك ونستخدمها ونحميها عند استخدامك لخدمتنا لإنشاء الترجمة العربية بالذكاء الاصطناعي.
        </P>
      </Section>

      <Section title="2. المعلومات التي نجمعها">
        <P>نجمع الأنواع التالية من المعلومات:</P>
        <List>
          <li><strong>معلومات الحساب:</strong> الاسم والبريد الإلكتروني وكلمة المرور عند إنشاء حساب.</li>
          <li><strong>المحتوى:</strong> ملفات الفيديو والصوت التي ترفعها لإنشاء الترجمة.</li>
          <li><strong>بيانات الاستخدام:</strong> معلومات عن طريقة تفاعلك مع خدمتنا، بما في ذلك الميزات المستخدمة والوقت المستغرق.</li>
          <li><strong>معلومات الجهاز:</strong> نوع المتصفح ونظام التشغيل ومعرّفات الجهاز.</li>
        </List>
      </Section>

      <Section title="3. كيف نستخدم معلوماتك">
        <P>نستخدم معلوماتك من أجل:</P>
        <List>
          <li>تقديم خدمات إنشاء الترجمة وتحسينها</li>
          <li>معالجة المحتوى الذي ترفعه وإنشاء ترجمة دقيقة</li>
          <li>التواصل معك بخصوص حسابك وتحديثات الخدمة</li>
          <li>ضمان أمان منصتنا وسلامتها</li>
          <li>الالتزام بالمتطلبات القانونية</li>
        </List>
      </Section>

      <Section title="4. تخزين البيانات وأمانها">
        <P>
          تُخزَّن بياناتك بشكل آمن باستخدام تشفير وفق المعايير المعتمدة في المجال. نطبّق إجراءات تقنية وتنظيمية
          مناسبة لحماية بياناتك الشخصية من الوصول غير المصرح به أو التعديل أو الإفصاح أو الإتلاف.
        </P>
        <P>
          تتم معالجة ملفات الفيديو والصوت المرفوعة لإنشاء الترجمة، وقد تُخزَّن مؤقتًا لتقديم خدماتنا. يمكنك حذف
          محتواك في أي وقت من لوحة التحكم.
        </P>
      </Section>

      <Section title="5. مشاركة البيانات">
        <P>نحن لا نبيع بياناتك الشخصية. قد نشارك معلوماتك مع:</P>
        <List>
          <li><strong>مزوّدي الخدمات:</strong> خدمات خارجية تساعدنا في تشغيل منصتنا (الاستضافة، التحليلات، معالجة المدفوعات).</li>
          <li><strong>المتطلبات القانونية:</strong> عندما يقتضي القانون ذلك أو لحماية حقوقنا وسلامتنا.</li>
        </List>
      </Section>

      <Section title="6. حقوقك">
        <P>يحق لك:</P>
        <List>
          <li>الوصول إلى بياناتك الشخصية</li>
          <li>تصحيح البيانات غير الدقيقة</li>
          <li>حذف حسابك والبيانات المرتبطة به</li>
          <li>تصدير بياناتك</li>
          <li>إلغاء الاشتراك في الرسائل التسويقية</li>
        </List>
      </Section>

      <Section title="7. ملفات تعريف الارتباط (الكوكيز)">
        <P>
          نستخدم ملفات تعريف الارتباط الأساسية لإبقائك مسجلًا الدخول وتقديم خدماتنا. وقد نستخدم أيضًا ملفات تعريف
          ارتباط تحليلية لفهم طريقة استخدامك لمنصتنا وتحسين خدماتنا.
        </P>
      </Section>

      <Section title="8. خصوصية الأطفال">
        <P>
          خدمتنا غير موجهة للأطفال دون سن 13 عامًا، ولا نجمع عن قصد أي معلومات شخصية من الأطفال دون هذا السن.
        </P>
      </Section>

      <Section title="9. التغييرات على هذه السياسة">
        <P>
          قد نحدّث سياسة الخصوصية هذه من وقت لآخر. سنُعلمك بأي تغييرات مهمة بنشر السياسة الجديدة في هذه الصفحة
          وتحديث تاريخ "آخر تحديث".
        </P>
      </Section>

      <Section title="10. تواصل معنا">
        <P>إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه أو طريقة تعاملنا مع البيانات، يُرجى التواصل معنا على:</P>
        <p className="text-slate-600 leading-relaxed">
          <strong>البريد الإلكتروني:</strong> <span dir="ltr">privacy@arabcap.co</span>
        </p>
      </Section>
    </div>
  </div>
);

export default PrivacyPolicyAr;
